<template>
  <div class="d-flex justify-center flex-column mx-auto py-4" style="width: fit-content">
    <SUICalendar show-key @datesUpdated="showSelectedDates" />
    <v-alert class="pa-4 mx-auto" v-if="dates" dense outlined text color="light-blue" style="width: fit-content;">
      <strong class="blue--text text--darken-2">{{ dates.start }} - {{ dates.end }}</strong>
    </v-alert>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      dates: null,
    }
  },
  methods: {
    showSelectedDates (dates) {
      if (dates.start && dates.end) {
        this.dates = dates
      } else {
        this.dates = null
      }
    },
  },
}
</script>

<style></style>
